import type { Scalars } from '__generated__/graphql-types';
import moment from 'moment';

export function isWithinSixMonths(launchedAt: Scalars['DateTime'] | null | undefined | number): boolean {
  if (!launchedAt) {
    return false;
  }

  const currentDate = Date.now();
  const differenceInMilliseconds: number = currentDate - moment(launchedAt).valueOf();
  const millisecondsInSixMonths = 24 * 60 * 60 * 1000 * 30 * 6;
  return differenceInMilliseconds < millisecondsInSixMonths;
}
